/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NaturalPersonDto } from './NaturalPersonDto';
import {
    NaturalPersonDtoFromJSON,
    NaturalPersonDtoFromJSONTyped,
    NaturalPersonDtoToJSON,
    NaturalPersonDtoToJSONTyped,
} from './NaturalPersonDto';
import type { LegalEntityDto } from './LegalEntityDto';
import {
    LegalEntityDtoFromJSON,
    LegalEntityDtoFromJSONTyped,
    LegalEntityDtoToJSON,
    LegalEntityDtoToJSONTyped,
} from './LegalEntityDto';
import type { PersonTypeEnum } from './PersonTypeEnum';
import {
    PersonTypeEnumFromJSON,
    PersonTypeEnumFromJSONTyped,
    PersonTypeEnumToJSON,
    PersonTypeEnumToJSONTyped,
} from './PersonTypeEnum';

/**
 * 
 * @export
 * @interface SearchInsuredDetailsDto
 */
export interface SearchInsuredDetailsDto {
    /**
     * Unique identifier of the insurance actor
     * @type {string}
     * @memberof SearchInsuredDetailsDto
     */
    id: string;
    /**
     * 
     * @type {PersonTypeEnum}
     * @memberof SearchInsuredDetailsDto
     */
    type?: PersonTypeEnum;
    /**
     * Creation timestamp of the record
     * @type {Date}
     * @memberof SearchInsuredDetailsDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {NaturalPersonDto}
     * @memberof SearchInsuredDetailsDto
     */
    naturalPerson?: NaturalPersonDto;
    /**
     * 
     * @type {LegalEntityDto}
     * @memberof SearchInsuredDetailsDto
     */
    legalEntity?: LegalEntityDto;
}



/**
 * Check if a given object implements the SearchInsuredDetailsDto interface.
 */
export function instanceOfSearchInsuredDetailsDto(value: object): value is SearchInsuredDetailsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SearchInsuredDetailsDtoFromJSON(json: any): SearchInsuredDetailsDto {
    return SearchInsuredDetailsDtoFromJSONTyped(json, false);
}

export function SearchInsuredDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInsuredDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'] == null ? undefined : PersonTypeEnumFromJSON(json['type']),
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'naturalPerson': json['naturalPerson'] == null ? undefined : NaturalPersonDtoFromJSON(json['naturalPerson']),
        'legalEntity': json['legalEntity'] == null ? undefined : LegalEntityDtoFromJSON(json['legalEntity']),
    };
}

export function SearchInsuredDetailsDtoToJSON(json: any): SearchInsuredDetailsDto {
    return SearchInsuredDetailsDtoToJSONTyped(json, false);
}

export function SearchInsuredDetailsDtoToJSONTyped(value?: SearchInsuredDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': PersonTypeEnumToJSON(value['type']),
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'naturalPerson': NaturalPersonDtoToJSON(value['naturalPerson']),
        'legalEntity': LegalEntityDtoToJSON(value['legalEntity']),
    };
}

